(function () {
  var cartStateRequest = null;

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(String(cents), '${{amount}} USD');
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format((Number(cents) || 0) / 100);
  }

  function setCartBadgeCount(rawCount) {
    var count = Math.max(0, Number(rawCount) || 0);

    document.querySelectorAll('.js-cart-num').forEach(function (node) {
      node.textContent = String(count);
      node.classList.toggle('u-hidden', count < 1);
      node.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
    });
  }

  function fetchCartState(force) {
    if (!force && cartStateRequest) {
      return cartStateRequest;
    }

    cartStateRequest = fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-state');
        return response.json();
      })
      .then(function (cart) {
        setCartBadgeCount(cart && cart.item_count);
        return cart;
      })
      .finally(function () {
        cartStateRequest = null;
      });

    return cartStateRequest;
  }

  function initCartBadges(scope) {
    if (scope && scope.querySelectorAll) {
      var scopedCountNodes = Array.from(scope.querySelectorAll('[data-sa-cart-count]'));
      if (scopedCountNodes.length) {
        var maxCount = 0;
        scopedCountNodes.forEach(function (node) {
          var parsedCount = Number(String(node.textContent || '').replace(/[^\d]/g, '')) || 0;
          if (parsedCount > maxCount) {
            maxCount = parsedCount;
          }
        });
        setCartBadgeCount(maxCount);
      }
    }

    if (document.body && document.body.dataset.saCartBadgesReady === 'true') {
      return;
    }

    if (document.body) {
      document.body.dataset.saCartBadgesReady = 'true';
    }

    fetchCartState().catch(function () {});
  }

  function normalizeInternalLinks(scope) {
    scope.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';

      if (
        href === '/community/contact' ||
        href.indexOf('sonnyangelusa.com/community/contact') >= 0 ||
        href.indexOf('claims.sonnyangelusa.com') >= 0
      ) {
        link.setAttribute('href', '/pages/contact-us');
      }
    });
  }

  function removeAboutMediaLinks(scope) {
    scope.querySelectorAll('.p-about-media-content').forEach(function (content) {
      var wrap = content.closest('.p-about-wrap');
      if (wrap) {
        wrap.remove();
        return;
      }

      content.remove();
    });
  }

  function getVariantButtons(root) {
    return Array.from(root.querySelectorAll('[data-sa-variant-button]'));
  }

  function activateTabGroup(group) {
    var buttons = Array.from(group.querySelectorAll('[data-sa-tab-button]'));
    var panels = Array.from(group.querySelectorAll('[data-sa-tab-panel]'));

    function show(id) {
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-sa-tab-button') === id;
        button.classList.toggle('c-tab-item__link--active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-sa-tab-panel') === id;
        panel.classList.toggle('u-hidden', !active);
        panel.hidden = !active;
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        show(button.getAttribute('data-sa-tab-button'));
      });
    });

    if (buttons[0]) {
      show(buttons[0].getAttribute('data-sa-tab-button'));
    }
  }

  function initTabs(scope) {
    scope.querySelectorAll('[data-sa-tab-set]').forEach(function (group) {
      if (group.dataset.saReady === 'true') return;
      group.dataset.saReady = 'true';
      activateTabGroup(group);
    });
  }

  function initPickupCarousel(scope) {
    scope.querySelectorAll('[data-sa-pickup-carousel]').forEach(function (wrap) {
      if (wrap.dataset.saSwiperReady === 'true') return;
      wrap.dataset.saSwiperReady = 'true';

      if (typeof window.Swiper !== 'function') return;

      var container = wrap.querySelector('.js-pickup-carousel');
      if (!container) return;

      new window.Swiper(container, {
        slidesPerView: 3,
        spaceBetween: 32,
        loop: false,
        navigation: {
          nextEl: wrap.querySelector('.c-pickup-nav-arrow--next'),
          prevEl: wrap.querySelector('.c-pickup-nav-arrow--prev'),
        },
        pagination: {
          el: wrap.querySelector('.c-pickup-nav-pagination'),
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 2,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        },
      });
    });
  }

  function initMobileMenu(scope) {
    scope.querySelectorAll('[data-sa-mobile-shell]').forEach(function (shell) {
      if (shell.dataset.saReady === 'true') return;
      shell.dataset.saReady = 'true';

      var toggle = shell.querySelector('[data-sa-mobile-toggle]');
      var panel = shell.querySelector('[data-sa-mobile-panel]');

      function setOpen(open) {
        if (!panel) return;
        panel.hidden = !open;
        panel.classList.toggle('bottom-menu--active', open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (toggle) {
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.classList.toggle('bottom-bar-link--close', open);
        }
        document.documentElement.classList.toggle('sa-mobile-nav-open', open);
      }

      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          setOpen(panel.hidden);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel && !panel.hidden) {
          setOpen(false);
        }
      });

      setOpen(false);
    });
  }

  function initBackToTop(scope) {
    scope.querySelectorAll('.js-page-top').forEach(function (link) {
      if (link.dataset.saReady === 'true') return;
      link.dataset.saReady = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function initCollectionControls(scope) {
    scope.querySelectorAll('[data-sa-collection-controls]').forEach(function (controls) {
      if (controls.dataset.saReady === 'true') return;
      controls.dataset.saReady = 'true';

      var targetSelector = controls.getAttribute('data-sa-target');
      var target = targetSelector ? document.querySelector(targetSelector) : null;
      var gridButtons = Array.from(controls.querySelectorAll('[data-grid]'));
      var sortTrigger = controls.querySelector('.js-filter-pull, .c-filter-pull-title__link');
      var sortIcon = controls.querySelector('.c-filter-pull-title__icon');
      var sortBody = controls.querySelector('.c-filter-pull-body');
      var sortLinks = Array.from(controls.querySelectorAll('[data-sort]'));
      var currentSort = new URL(window.location.href).searchParams.get('sort_by');

      function setGrid(view) {
        gridButtons.forEach(function (button) {
          button.classList.toggle('c-filter-grid-item__button--active', button.getAttribute('data-grid') === view);
        });

        if (!target) return;

        target.classList.toggle('c-product-loop--large', view === 'column');
        target.querySelectorAll('.c-product-item').forEach(function (item) {
          item.classList.toggle('c-product-item--large', view === 'column');
        });
      }

      function setSortOpen(open) {
        if (sortIcon) {
          sortIcon.classList.toggle('c-filter-pull-title__icon--close', open);
        }

        if (sortBody) {
          sortBody.classList.toggle('c-filter-pull-body--active', open);
        }
      }

      function setActiveSort(value) {
        sortLinks.forEach(function (link) {
          link.classList.toggle('c-filter-pull-list-item__link--active', link.getAttribute('data-sort') === value);
        });
      }

      var savedGrid = window.localStorage ? window.localStorage.getItem('grid') : null;
      setGrid(savedGrid === 'column' ? 'column' : 'row');
      if (currentSort) {
        setActiveSort(currentSort);
      }

      gridButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var view = button.getAttribute('data-grid');
          if (window.localStorage) {
            window.localStorage.setItem('grid', view);
          }
          setGrid(view);
        });
      });

      if (sortTrigger) {
        sortTrigger.addEventListener('click', function (event) {
          event.preventDefault();
          setSortOpen(!(sortBody && sortBody.classList.contains('c-filter-pull-body--active')));
        });
      }

      sortLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var value = link.getAttribute('data-sort');
          var url = new URL(window.location.href);
          setActiveSort(value);
          setSortOpen(false);
          url.searchParams.set('sort_by', value);
          window.location.href = url.toString();
        });
      });
    });
  }

  function syncGallery(root, mediaIndex) {
    var slides = Array.from(root.querySelectorAll('[data-sa-gallery-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-sa-thumb]'));
    slides.forEach(function (slide) {
      var active = slide.getAttribute('data-sa-gallery-slide') === mediaIndex;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute('data-sa-thumb') === mediaIndex;
      thumb.classList.toggle('p-product-thumb-nav__link--active', active);
    });
  }

  function updateProductState(root, source) {
    var select = root.querySelector('select[name="id"]');
    var priceTarget = root.querySelector('[data-sa-price]');
    var compareTarget = root.querySelector('[data-sa-compare]');
    var skuTarget = root.querySelector('[data-sa-sku]');
    var button = root.querySelector('[data-sa-add-to-cart]');

    if (select) {
      select.value = source.getAttribute('data-variant-id');
    }

    if (priceTarget) {
      priceTarget.textContent = money(source.getAttribute('data-price'));
    }

    if (compareTarget) {
      var compare = Number(source.getAttribute('data-compare') || 0);
      var price = Number(source.getAttribute('data-price') || 0);
      compareTarget.textContent = compare > price ? money(compare) : '';
      compareTarget.hidden = !(compare > price);
    }

    if (skuTarget) {
      skuTarget.textContent = source.getAttribute('data-sku') || '';
    }

    if (button) {
      var available = source.getAttribute('data-available') === 'true';
      button.disabled = !available;
      button.classList.toggle('is-disabled', !available);
      button.querySelector('span').textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    getVariantButtons(root).forEach(function (buttonItem) {
      buttonItem.classList.toggle('c-buy-select-item__link--active', buttonItem === source);
    });

    var mediaIndex = source.getAttribute('data-media-index');
    if (mediaIndex) {
      syncGallery(root, mediaIndex);
    }
  }

  function initProductForms(scope) {
    scope.querySelectorAll('[data-sa-product-root]').forEach(function (root) {
      if (root.dataset.saReady === 'true') return;
      root.dataset.saReady = 'true';

      var buttons = getVariantButtons(root);
      var minus = root.querySelector('[data-sa-qty-minus]');
      var plus = root.querySelector('[data-sa-qty-plus]');
      var input = root.querySelector('input[name="quantity"]');
      var form = root.querySelector('form');

      buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          updateProductState(root, button);
        });
      });

      root.querySelectorAll('[data-sa-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          syncGallery(root, thumb.getAttribute('data-sa-thumb'));
        });
      });

      function normalizeQuantityValue() {
        var raw = String(input.value || '').replace(/[^\d]/g, '');
        var value = Math.max(1, Number(raw || 1));
        input.value = String(value);
        return value;
      }

      if (input) {
        input.addEventListener('input', function () {
          input.value = String(input.value || '').replace(/[^\d]/g, '');
        });

        input.addEventListener('blur', function () {
          normalizeQuantityValue();
        });
      }

      if (minus && input) {
        minus.addEventListener('click', function () {
          input.value = Math.max(1, normalizeQuantityValue() - 1);
        });
      }

      if (plus && input) {
        plus.addEventListener('click', function () {
          input.value = Math.max(1, normalizeQuantityValue() + 1);
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var submitButton = form.querySelector('[data-sa-add-to-cart]');
          if (!submitButton || submitButton.disabled) return;

          if (input) {
            normalizeQuantityValue();
          }

          submitButton.disabled = true;
          submitButton.querySelector('span').textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: new FormData(form),
          })
            .then(function (response) {
              if (!response.ok) throw new Error('cart');
              return response.json();
            })
            .then(function () {
              return fetchCartState(true).catch(function () {
                return null;
              });
            })
            .then(function () {
              submitButton.querySelector('span').textContent = 'Thank you!';
              window.setTimeout(function () {
                submitButton.disabled = false;
                submitButton.querySelector('span').textContent = 'Add to Cart';
              }, 1200);
            })
            .catch(function () {
              submitButton.disabled = false;
              submitButton.querySelector('span').textContent = 'Sold Out';
            });
        });
      }

      if (buttons[0]) {
        updateProductState(root, buttons[0]);
      }
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderLegacyBrowsePrice(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var hasPackageVariants = variants.some(function (variant) {
      var title = String(variant && variant.title ? variant.title : '').toLowerCase();
      return (
        title.indexOf('box of') >= 0 ||
        title.indexOf('blind box') >= 0 ||
        title.indexOf('piece') >= 0 ||
        title.indexOf('bag') >= 0 ||
        title.indexOf('pack') >= 0 ||
        title.indexOf('capsule') >= 0
      );
    });

    if (variants.length > 1 && hasPackageVariants) {
      return variants
        .slice(0, 2)
        .map(function (variant) {
          return (
            '<p class="c-product-item-info__price">' +
            escapeHtml(variant.title) +
            '&nbsp;:&nbsp;' +
            money(variant.price) +
            '</p>'
          );
        })
        .join('');
    }

    if (variants.length > 1) {
      return '<p class="c-product-item-info__price">1 Piece&nbsp;:&nbsp;' + money(product.price_min) + '</p>';
    }

    return '<p class="c-product-item-info__price">' + money(product.price) + '</p>';
  }

  function renderLegacyBrowseCard(product, collectionHandle) {
    var image = product.featured_image || (Array.isArray(product.images) && product.images[0] ? product.images[0].src || product.images[0] : '');
    var tagText = '';
    var tags = Array.isArray(product.tags) ? product.tags : [];

    tags.forEach(function (tag) {
      var normalized = String(tag).toLowerCase();
      if (normalized.indexOf('coming soon') >= 0) {
        tagText = 'coming soon';
        return;
      }
      if (!tagText && normalized.indexOf('new') >= 0) {
        tagText = 'NEW';
      }
    });

    var productUrl = '/collections/' + collectionHandle + '/products/' + product.handle;
    var labelHtml = '';
    if (tagText) {
      labelHtml =
        '<span class="c-label-icon ' +
        (tagText === 'NEW' ? 'c-label-icon--new' : 'c-label-icon--commingsoon') +
        '">' +
        escapeHtml(tagText) +
        '</span>';
    }

    return (
      '<div class="c-product-item c-product-item--large">' +
      '<div class="c-product-item-thumb">' +
      '<a href="' + escapeHtml(productUrl) + '" class="c-product-item-thumb__link" data-img="">' +
      (image
        ? '<img src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(product.title) +
          '" class="c-product-item-thumb__img c-product-item-thumb__img--main">'
        : '') +
      '</a>' +
      '</div>' +
      '<div class="c-product-item__body">' +
      '<p class="c-product-item-icon">' +
      labelHtml +
      '</p>' +
      '<div class="c-product-item-main">' +
      '<h3 class="c-product-item__title"><a href="' +
      escapeHtml(productUrl) +
      '">' +
      escapeHtml(product.title) +
      '</a></h3>' +
      '</div>' +
      '<div class="c-product-item-info">' +
      renderLegacyBrowsePrice(product) +
      '</div>' +
      '<p class="c-product-item-button">' +
      '<a href="' +
      escapeHtml(productUrl) +
      '" class="c-button u-mx-0"><span>View Detail<span class="is-sr0nly">&nbsp;about ' +
      escapeHtml(product.title) +
      '</span></span></a>' +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function initLegacyBrowseFallback(scope) {
    var legacySection = Array.from(scope.querySelectorAll('.shopify-section')).find(function (section) {
      var heading = section.querySelector('.c-headline__main');
      if (!heading || heading.textContent.replace(/\s+/g, ' ').trim() !== 'BROWSE') return false;
      return !section.querySelector('[data-sa-tab-set]') && section.querySelector('.js-tab-search-first') && section.querySelector('.c-tab-item__link');
    });

    if (!legacySection || legacySection.dataset.saBrowsePatched === 'true') return;
    legacySection.dataset.saBrowsePatched = 'true';

    var collectionMap = {
      New: 'browse-new',
      Recommended: 'browse-recommended',
      'Regular Series': 'browse-regular-series',
    };

    Object.keys(collectionMap).forEach(function (label) {
      var button = Array.from(legacySection.querySelectorAll('.c-tab-item__link')).find(function (link) {
        return link.textContent.replace(/\s+/g, ' ').trim() === label;
      });
      if (!button) return;

      var panelId = button.getAttribute('data-tab');
      var panel = panelId ? legacySection.querySelector('#' + panelId) : null;
      if (!panel) return;

      fetch('/collections/' + collectionMap[label] + '/products.json?limit=6')
        .then(function (response) {
          if (!response.ok) throw new Error('browse');
          return response.json();
        })
        .then(function (payload) {
          var products = Array.isArray(payload.products) ? payload.products : [];
          if (!products.length) return;
          panel.innerHTML = products
            .map(function (product) {
              return renderLegacyBrowseCard(product, collectionMap[label]);
            })
            .join('');
        })
        .catch(function () {
          legacySection.dataset.saBrowsePatched = 'error';
        });
    });
  }

  function initCartPage(scope) {
    scope.querySelectorAll('[data-sa-cart-root]').forEach(function (root) {
      if (root.dataset.saCartReady === 'true') return;
      root.dataset.saCartReady = 'true';

      var countNodes = Array.from(root.querySelectorAll('[data-sa-cart-count]'));
      var totalNodes = Array.from(root.querySelectorAll('[data-sa-cart-total]'));
      var lineItems = Array.from(root.querySelectorAll('[data-sa-cart-line-item]'));
      var quantityInputs = Array.from(root.querySelectorAll('input[data-sa-cart-quantity]'));

      function sanitizeValue(input) {
        var min = Number(input.getAttribute('min')) || 1;
        var max = Number(input.getAttribute('max')) || Infinity;
        var digits = String(input.value || '').replace(/[^\d]/g, '');
        var value = Number(digits || min);

        if (!Number.isFinite(value) || value < min) {
          value = min;
        }
        if (value > max) {
          value = max;
        }

        input.value = String(value);
        return value;
      }

      function readValue(input) {
        var min = Number(input.getAttribute('min')) || 1;
        var max = Number(input.getAttribute('max')) || Infinity;
        var digits = String(input.value || '').replace(/[^\d]/g, '');
        var value = Number(digits || min);

        if (!Number.isFinite(value) || value < min) {
          value = min;
        }
        if (value > max) {
          value = max;
        }

        return value;
      }

      function updateSummary(shouldNormalize) {
        var totalItems = 0;
        var totalCents = 0;

        lineItems.forEach(function (lineItem) {
          var input = lineItem.querySelector('input[data-sa-cart-quantity]');
          if (!input) return;

          var quantity = shouldNormalize ? sanitizeValue(input) : readValue(input);
          var unitPrice = Number(lineItem.getAttribute('data-sa-unit-price') || 0);
          var linePrice = unitPrice * quantity;
          var priceNode = lineItem.querySelector('[data-sa-line-price]');

          totalItems += quantity;
          totalCents += linePrice;

          if (priceNode) {
            priceNode.textContent = money(linePrice);
          }
        });

        countNodes.forEach(function (node) {
          node.textContent = String(totalItems);
        });

        totalNodes.forEach(function (node) {
          node.textContent = money(totalCents);
        });

        document.querySelectorAll('.js-cart-num').forEach(function (node) {
          node.textContent = String(totalItems);
          node.classList.toggle('u-hidden', totalItems < 1);
        });
      }

      quantityInputs.forEach(function (input) {
        input.addEventListener('input', function () {
          input.value = String(input.value || '').replace(/[^\d]/g, '');
          updateSummary(false);
        });

        input.addEventListener('change', function () {
          sanitizeValue(input);
          updateSummary(true);
        });

        input.addEventListener('blur', function () {
          sanitizeValue(input);
          updateSummary(true);
        });
      });

      root.querySelectorAll('[data-sa-cart-minus]').forEach(function (button) {
        button.addEventListener('click', function () {
          var input = button.parentElement ? button.parentElement.querySelector('input[data-sa-cart-quantity]') : null;
          if (!input) return;

          var min = Number(input.getAttribute('min')) || 1;
          var nextValue = Math.max(min, sanitizeValue(input) - 1);
          input.value = String(nextValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      root.querySelectorAll('[data-sa-cart-plus]').forEach(function (button) {
        button.addEventListener('click', function () {
          var input = button.parentElement ? button.parentElement.querySelector('input[data-sa-cart-quantity]') : null;
          if (!input) return;

          var max = Number(input.getAttribute('max')) || Infinity;
          var nextValue = Math.min(max, sanitizeValue(input) + 1);
          input.value = String(nextValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      updateSummary(true);
    });
  }

  function init(scope) {
    initCartBadges(scope);
    normalizeInternalLinks(scope);
    removeAboutMediaLinks(scope);
    initCartPage(scope);
    initLegacyBrowseFallback(scope);
    initTabs(scope);
    initPickupCarousel(scope);
    initMobileMenu(scope);
    initBackToTop(scope);
    initCollectionControls(scope);
    initProductForms(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
